import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../WorkoutTemplateBuilder'

import SetUnitsButton from '../Buttons/Set/SetUnitsButton'
import DuplicateSetButton from '../Buttons/Set/DuplicateSetButton'
import DeleteSetButton from '../Buttons/Set/DeleteSetButton'

export default function SetDetailCards({ phase, phaseIndex, exercise, exerciseIndex }) {
    const { mode, mutateExercise } = useContext(WorkoutTemplateBuilderContext)

    return (
        <>
            {exercise.sets.map((set, setIndex) => (
                <div key={setIndex} className="h-6 flex items-center pl-2 border-t border-stone-400 text-gray-500 text-xs">
                    {/* Current Set */}
                    <p className="flex-grow">
                        Set {setIndex + 1}/{exercise.sets.length}
                    </p>

                    {/* Set Reps Button */}
                    <SetUnitsButton mode={mode} phaseIndex={phaseIndex} exerciseIndex={exerciseIndex} exercise={exercise} setIndex={setIndex} set={set} mutateExercise={mutateExercise} />

                    {/* Right Hand Side */}
                    <div className="flex items-center">
                        {/* Duplicate Exercise Set Button */}
                        <DuplicateSetButton mode={mode} phaseType={phase.type} phaseIndex={phaseIndex} exerciseIndex={exerciseIndex} setIndex={setIndex} mutateExercise={mutateExercise} />

                        {/* Delete Exercise Set Button */}
                        <DeleteSetButton mode={mode} phaseType={phase.type} phaseIndex={phaseIndex} exerciseIndex={exerciseIndex} setIndex={setIndex} mutateExercise={mutateExercise} />
                    </div>
                </div>
            ))}
        </>
    )
}
